import { TFunction } from 'i18next';
import React, { FC } from 'react';
import { ConfiguratorCodelist } from '../../../types/generated/configuratorCodelist';
import SingleCodeList from './SingleCodeList';

const TabCodelists: FC<{
    codelists?: ConfiguratorCodelist[];
    t: TFunction;
}> = ({ codelists, t }) => {
    if (!codelists) return <div>No codelists found</div>;
    return (
        <div>
            <div className="flex text-dove text-caption p-5 pl-0 justify-between border-b border-alto">
                <p className="w-9/12 pl-2">
                    {t('form-configurator:BusinessTerm').toUpperCase()}
                </p>
                <p className="w-4/12 flex justify-center">
                    {t('form-configurator:Status').toUpperCase()}
                </p>
                <p className="w-4/12 flex justify-center">
                    {t('form-configurator:LastChanged').toUpperCase()}
                </p>
                <p className="w-5/12 pl-2 flex justify-center">
                    {t('form-configurator:User').toUpperCase()}
                </p>
            </div>
            <div className="overflow-auto" style={{ height: '40vh' }}>
                {codelists.map((codelist) => (
                    <SingleCodeList
                        key={codelist.name}
                        codelist={codelist}
                        t={t}
                    />
                ))}
            </div>
        </div>
    );
};

export default TabCodelists;
